import React from 'react';
import PropTypes from 'prop-types';
import { renderToString } from 'react-dom/server';
import { spring, StaggeredMotion } from 'react-motion';
import {
  Image,
  SharingPopup,
  DataHandler,
  StorageHandler,
  APIHandler,
} from 'C4';
import { storageKeys } from 'settings';

const trackShare = (type, value, title) => {
  DataHandler.matchAppId().then((appId) => {
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'Guest';
      if (userObj && userObj) {
        ({ email } = userObj);
      }
      APIHandler.trackEvent(appId, email, 'videos', type, value, title).then(
        () => { },
      );
    });
  });
};

const ImageCollection = (props) => {
  const { chapterCollection } = props;
  const { chapter } = chapterCollection[0];

  // Dynamically Create enough animation starting values
  const startingValues = [];
  Object.keys(chapterCollection).map(() => {
    const newObj = {};
    newObj.pos = 0;
    return startingValues.push(newObj);
  });

  const fancyOptions = (url, image, title) => ({
    infobar: true,
    thumbs: {
      autoStart: true,
      axis: 'x',
    },
    baseClass: 'customBox',
    buttons: ['thumbs', 'share', 'close'],
    share: {
      tpl: renderToString(
        <SharingPopup url={url} image={image} title={title} />,
      ),
    },
    caption: title,
  });

  return (
    <div className="imageGrid__Container">
      <div className="imageGrid__Container--title">
        <h3>{chapter.chapterTitle}</h3>
        <h5>{`Chapter ${chapter.chapterNumber}`}</h5>
      </div>
      <StaggeredMotion
        defaultStyles={startingValues}
        styles={(prevInterpolatedStyles) =>
          prevInterpolatedStyles.map((_, i) =>
            i === 0
              ? { pos: spring(1, { stiffness: 320, damping: 28 }) }
              : {
                pos: spring(prevInterpolatedStyles[i - 1].pos, {
                  stiffness: 320,
                  damping: 28,
                }),
              },
          )
        }
      >
        {(styles) => (
          <div className="imageGrid__Grid">
            {Object.values(chapterCollection).map((item, index) => {
              const { pageID, title, image } = item;
              return (
                <div
                  className="imageGrid_Card"
                  key={pageID}
                  style={{ opacity: `${styles[index].pos}` }}
                  href={image}
                  data-fancybox={chapter.chapterTitle}
                  data-options={JSON.stringify(
                    fancyOptions(image, image, title),
                  )}
                  data-caption={title}
                  onClick={() => trackShare('collectionItem', image, title)}
                >
                  {image.length > 0 && (
                    <img
                      key={pageID}
                      src={image}
                      gradient
                      fancybox={chapter.chapterTitle}
                    />
                  )}
                  <h6
                    className="title"
                    dangerouslySetInnerHTML={{
                      __html: title.toString('utf-8'),
                    }}
                  />
                </div>
              );
            })}
          </div>
        )}
      </StaggeredMotion>
    </div>
  );
};

export default ImageCollection;

ImageCollection.propTypes = {
  chapterCollection: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string,
      pageID: PropTypes.number,
      image: PropTypes.string,
      url: PropTypes.string,
      chapter: PropTypes.shape({
        chapterNumber: PropTypes.number,
        chapterTitle: PropTypes.string,
        chapterImage: PropTypes.string,
      }),
    }),
  ).isRequired,
};
